<template>
  <div :class="$vuetify.breakpoint.xsOnly ? 'px-4' : ''">
    <div class="d-flex align-center mb-3 flex-wrap">
      <span class="caption text--secondary">{{ $t('quotations.texts.line_hint') }}</span>
      <v-spacer />
      <v-btn text color="primary" :disabled="saving" @click="$emit('copy-texts')">
        <v-icon left>mdi-content-copy</v-icon>
        {{ $t('quotations.texts.copy_texts') }}
      </v-btn>
    </div>

    <v-card v-for="block in blocks" :key="block" :elevation="$vuetify.breakpoint.xsOnly ? 0 : ''" class="mb-4">
      <v-card-title class="subtitle-1 text-uppercase font-weight-medium pb-1">{{ $t(`quotations.texts.${block}`) }}</v-card-title>
      <v-card-text>
        <v-textarea v-model="quotation.texts[block]" :disabled="saving" outlined auto-grow rows="2" hide-details />
      </v-card-text>
    </v-card>

    <v-card :elevation="$vuetify.breakpoint.xsOnly ? 0 : ''" class="mb-4">
      <v-card-title class="subtitle-1 text-uppercase font-weight-medium pb-1">{{ $t('quotations.texts.structured') }}</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="4">
            <v-select v-model="quotation.paymentTerm" :items="paymentTermOptions" :label="$t('quotations.texts.payment_term')" :disabled="saving" outlined dense hide-details />
          </v-col>
          <v-col v-if="quotation.paymentTerm === 'other'" cols="12" sm="8">
            <v-text-field v-model="quotation.paymentTermText" :label="$t('quotations.texts.payment_term_text')" :disabled="saving" outlined dense hide-details />
          </v-col>
        </v-row>
        <v-row dense class="mt-2">
          <v-col cols="12" sm="4">
            <v-text-field v-model="quotation.duration" :label="$t('quotations.texts.duration')" :disabled="saving" outlined dense hide-details placeholder="3 vk" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'QuotationTextsTab',
  props: {
    quotation: { type: Object, required: true },
    saving: { type: Boolean, default: false },
  },
  data() {
    return {
      blocks: ['intro', 'included', 'reservations', 'obligations', 'other', 'contact'],
      paymentTermOptions: ['14', '30', 'other'].map(v => ({ text: this.$t(`quotations.texts.payment_terms.${v}`), value: v })),
    };
  },
};
</script>
